import React from 'react';
import { useHistory } from 'react-router-dom';

import { walkExitMessage } from '../../utils/applicationEditSession';
import Modal from '../Modal/Modal';

interface WalkExitModalProps {
  status: 'replaced' | 'closed';
  exitPath: string;
}

/**
 * Edit Identity: shown on an underwriting page whose tab can no longer write —
 * its walk was replaced in another tab, or none is open. The only way on is
 * out: to the quote page, or to a new application. `replace`, so the browser's
 * Back does not return to the page that cannot save.
 */
const WalkExitModal: React.FC<WalkExitModalProps> = ({ status, exitPath }) => {
  const history = useHistory();
  return (
    <Modal
      onAction={() => history.replace(exitPath)}
      actionName={exitPath === '/' ? 'Start a new application' : 'Go to quote'}
    >
      <div className="text-primary">
        <p>{walkExitMessage(status, exitPath)}</p>
      </div>
    </Modal>
  );
};

export default WalkExitModal;
